/* eslint-disable array-bracket-newline */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Text from '../../atoms/Text';
import { IMobileFilterProps } from '../SearchTable/SearchTable';
import { WatchlistWallet } from '../../reducers/wallet_watchlist';
import { IStore } from '../../reducers';

import './styles.scss';

enum SortOption {
  Unset = '',
  ABC = 'ABC',
  LowValue = 'Low value',
  Tags = 'Tags',
  HighValue = 'High value',
}

type sortOptionsType = {
  icon: string;
  title: SortOption;
}[];

const sortOptions: sortOptionsType = [
  {
    icon: 'icon-sort',
    title: SortOption.ABC,
  },
  {
    icon: 'icon-sort-arrow-down',
    title: SortOption.LowValue,
  },
  {
    icon: 'icon-sort-arrow-up',
    title: SortOption.HighValue,
  },
  {
    icon: 'icon-tag',
    title: SortOption.Tags,
  },
];

const getValue = (wallet: WatchlistWallet) => {
  const isBigTradeWallet = 'value_usd' in wallet;
  const isActiveWallet = 'volume_24' in wallet;
  if (isBigTradeWallet) {
    return wallet.value_usd;
  }
  if (isActiveWallet) {
    return wallet.volume_24;
  }
  return wallet.balance_usd;
};

export interface IMobileWalletsSortProps extends IMobileFilterProps {
  initialData: {
    wallets: WatchlistWallet[];
    selected: SortOption;
  };
}

const MobileWalletsSort = ({
  initialData,
  setSortValue,
}: IMobileWalletsSortProps) => {
  const tags = useSelector((state: IStore) => state.walletTags);
  const [active, setActive] = useState<SortOption>(initialData.selected);

  const onOptionClick = (currentOption: SortOption) => {
    if (active === currentOption) {
      return setActive(SortOption.Unset);
    }
    setActive(currentOption);
  };

  useEffect(() => {
    const copiedWallets = [...initialData.wallets];
    if (!active) {
      setSortValue!({ wallets: copiedWallets, selected: SortOption.Unset });
    }
    if (active === SortOption.ABC) {
      const sorted = copiedWallets.sort((a, b) => {
        const aTag = tags[a.chain]?.[a.address]?.[0];
        const bTag = tags[b.chain]?.[b.address]?.[0];
        const aName = aTag || a.nickname;
        const bName = bTag || b.nickname;
        return aName.localeCompare(bName);
      });
      setSortValue!({ wallets: sorted, selected: SortOption.ABC });
    }
    if (active === SortOption.LowValue) {
      const sorted = copiedWallets.sort((a, b) => {
        const aValue = getValue(a);
        const bValue = getValue(b);
        return bValue - aValue;
      });
      setSortValue!({ wallets: sorted, selected: SortOption.LowValue });
    }
    if (active === SortOption.HighValue) {
      const sorted = copiedWallets.sort((a, b) => {
        const aValue = getValue(a);
        const bValue = getValue(b);
        return aValue - bValue;
      });
      setSortValue!({ wallets: sorted, selected: SortOption.HighValue });
    }
    if (active === SortOption.Tags) {
      const sorted = copiedWallets.sort((a, b) => {
        const aTag = tags[a.chain]?.[a.address]?.[0];
        const bTag = tags[b.chain]?.[b.address]?.[0];

        if (aTag && !bTag) {
          return -1;
        }
        if (!aTag && bTag) {
          return 1;
        }
        return 0;
      });
      setSortValue!({ wallets: sorted, selected: SortOption.Tags });
    }
  }, [active, initialData, setSortValue, tags]);

  return (
    <>
      {sortOptions.map((option) => {
        const isActive = option.title === active;
        return (
          <div
            key={option.icon}
            className={`mobile_sort__item${
              isActive ? ' mobile_sort__item--active' : ''
            }`}
            onClick={() => onOptionClick(option.title)}
          >
            <div className='mobile_sort__item__content'>
              <div className={`mobile_sort__item__icon ${option.icon}`} />
              <Text
                size={14}
                className={`text--weight-500 ${
                  isActive ? 'text--grey-200' : 'text--grey-400'
                }`}
              >
                {option.title}
              </Text>
            </div>
            {isActive && (
              <div className='mobile_sort__item__icon mobile_sort__item__icon--active icon-check' />
            )}
          </div>
        );
      })}
    </>
  );
};

export default MobileWalletsSort;
